<template>
  <main class="company">
    <article class="row">
      <section class="col s4"/>
      <section class="col s4">
        <h4><strong>Company</strong></h4>
      </section>
      <autocomplete id="company-company-autocomplete"
                    name="Company Search"
                    size="s4"
                    :picks="$store.getters.companiesAutocompleteData"
                    watermark="Company Ticker/Name"
                    :disabled="false"
                    @picked="handleCompanyAutocomplete"
                    v-if="$store.getters.companiesAutocompleteData.length"
      />
    </article>
    <article class="row">
      <section class="col s5">
        <company-panel :company="company" />
        <company-quote-panel v-for="instrumentId of instrumentIds" :key="instrumentId" :instrument-id="instrumentId" />
      </section>
      <section class="col s7">
        <article class="row">
          <section class="col s12">
            <company-chart-tv v-if="isPrimary" :symbol="primaryFullyQualified" />
          </section>
        </article>
      </section>
    </article>
    <article class="row">
      <section class="col s9">
        <activity-feed :company-id="companyId"/>
      </section>
      <section class="col s3">
        <company-followers :company-id="companyId"/>
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import Autocomplete from '@/components/Autocomplete.vue';
import CompanyQuotePanel from '@/components/CompanyQuotePanel.vue';
import CompanyPanel from '@/components/CompanyPanel.vue';
import ActivityFeed from '@/components/ActivityFeed.vue';
import CompanyFollowers from '@/components/CompanyFollowers.vue';
import CompanyChartTv from '@/components/CompanyChartTv.vue';

export default {
  name: 'Company',
  components: { Autocomplete, CompanyPanel, CompanyQuotePanel, ActivityFeed, CompanyFollowers, CompanyChartTv },
  data() {
    return {
      company: {
        name: '',
        country: {
          code: 'br',
          geography: {
            region: '',
          },
        },
        sector: {
          name: '',
        },
        instruments: [],
      },
    };
  },
  computed: {
    companyId() {
      return Number(this.$route.query.company_id);
    },
    instrumentIds() {
      return this.company.instruments.map(instrument => instrument.id);
    },
    isPrimary() {
      return this.company.instruments.filter(instrument => instrument.is_primary)[0];
    },
    primaryFullyQualified() {
      const primary = this.company.instruments.filter(instrument => instrument.is_primary)[0];
      return `${primary.exchange.quotes_symbol}:${primary.symbol}`;
    },
  },
  watch: {},
  methods: {
    handleCompanyAutocomplete(choice) {
      const companyId = choice.slice(choice.indexOf('#') + 1, choice.length);
      // Workaround since navigating to same route doesn't update view
      this.$router.push('/loading');
      setTimeout(() => {
        this.$router.push(`/company?company_id=${companyId}`);
      }, 100);
    },
    async fetchCompany() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/company/?company_id=${this.companyId}&include_capiq=false`);
      this.company = data;
    },
  },
  mounted() {
    this.fetchCompany();
  },
};
</script>
